import { Component, HostListener, OnChanges, OnInit, SimpleChanges, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { MatDrawer } from '@angular/material/sidenav';
import { NavigationEnd, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { Dealer } from 'src/app/public/account/models/dealer.model';
import { selectDealerFetchingResults, selectLoggedInUserDataId } from 'src/app/common/store/state/app.state';


@Component({
    selector: 'app-dealer-car',
    templateUrl: './dealer-car.component.html',
    styleUrls: ['../common/session-style.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DealerCarComponent implements OnInit{

    currentUserId$: Observable<string>;
    currentUserId: string = "";

    dealerData = new Dealer();

    fetchingResults$: Observable<boolean>;

    isHandset: boolean = false;
    MIN_WIDTH: number = 800;

    @ViewChild('drawer') drawer!: MatDrawer;
  
    constructor(
  
      private store: Store, 
      private router: Router) { 

        this.fetchingResults$ = store.select(selectDealerFetchingResults);
  
        this.currentUserId$ = store.select(selectLoggedInUserDataId);
      }
  
      ngOnInit(): void {

        this.isHandset = (window.innerWidth < this.MIN_WIDTH); 
      
        this.currentUserId$.subscribe(
          (userId: string) => {
            this.currentUserId = userId;
          }
        );

        this.router.events.subscribe(event => {
          if (event instanceof NavigationEnd) {
            //console.log('URL changed:', event.url);
            this.drawer?.close()
          }
        }); 
               
      }

      goToSellerPublicPage(): any{
  
        this.router.navigate(
          ['/account/seller-public'],
          { queryParams: { id: this.currentUserId } }
        );
      }

      onResize(event: any) {
 
        this.isHandset = (window.innerWidth < this.MIN_WIDTH);  
      }
  
  }
  